export enum PMaxLines {
  ONE = '1',
  TWO = '2',
  TREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
}

export enum PWhiteSpace {
  NOWRAP = 'nowrap',
  NORMAL = 'normal',
  PRE_LINE = 'pre-line',
}
